import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/utenze", label: "Utenze" },
  { to: "/credito", label: "Credito" },
  { to: "/assicurazioni", label: "Assicurazioni" },
  { to: "/piano", label: "Piano ViviTranquillo" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isAuthed = user && user !== false;

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <Logo />

        <div className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]/g, "")}`}
              className={`text-sm font-semibold transition-colors ${
                pathname === l.to ? "text-[#10B981]" : "text-slate-600 hover:text-[#0A192F]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          {isAuthed ? (
            <button
              data-testid="nav-area-btn"
              onClick={() => navigate("/area")}
              className="rounded-full bg-[#0A192F] px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
            >
              Area Clienti
            </button>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="text-sm font-semibold text-[#0A192F] transition-colors hover:text-[#10B981]"
              >
                Accedi
              </Link>
              <Link
                to="/registrazione"
                data-testid="nav-register"
                className="rounded-full bg-[#10B981] px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#059669]"
              >
                Registrati
              </Link>
            </>
          )}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-6 w-6 text-[#0A192F]" /> : <Menu className="h-6 w-6 text-[#0A192F]" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-slate-200 bg-white px-6 py-4 lg:hidden">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/[^a-z]/g, "")}`}
                className="text-base font-semibold text-slate-700"
              >
                {l.label}
              </Link>
            ))}
            <div className="mt-2 flex flex-col gap-3 border-t border-slate-100 pt-4">
              {isAuthed ? (
                <button
                  data-testid="nav-mobile-area-btn"
                  onClick={() => { setOpen(false); navigate("/area"); }}
                  className="rounded-full bg-[#0A192F] px-6 py-3 text-sm font-semibold text-white"
                >
                  Area Clienti
                </button>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} data-testid="nav-mobile-login" className="rounded-full border-2 border-slate-200 px-6 py-3 text-center text-sm font-semibold text-[#0A192F]">
                    Accedi
                  </Link>
                  <Link to="/registrazione" onClick={() => setOpen(false)} data-testid="nav-mobile-register" className="rounded-full bg-[#10B981] px-6 py-3 text-center text-sm font-semibold text-white">
                    Registrati
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
